import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  getAllSupervisor,
  selectAllSupervisor,
} from "../../redux/users/usersSlice";
import { useNavigate, useParams } from "react-router-dom";
import UserEditModal from "../../components/employee/UserEditModal";
import { Icon } from "@iconify-icon/react/dist/iconify.mjs";
import { deleteUser } from "../../utils/api/users";
import { toast } from "react-toastify";
import PopConfirm from "../../components/company/PopConfirm";
import { selectAdmin } from "../../redux/admin/adminSlice";


function AllSupervisor() {
  const dispatch = useDispatch();
  const supervisor = useSelector(selectAllSupervisor);
  const [openModal, setOpenModal] = useState(false);
  const [user, setUser] = useState(null);
  const [refresh, setRefresh] = useState(false);
  const [confirmPopup, setConfirmPopup] = useState(false);
  const admin = useSelector(selectAdmin);
  // console.log(admin, "admin checking the")


  const navigate = useNavigate();

  const { companyId } = useParams();

  useEffect(() => {
    dispatch(getAllSupervisor(companyId));
  }, [dispatch, refresh]);

  const handleDeleteUser = async (user) => {
    try {
      await deleteUser(user.id);
      toast.success("User Deleted");
      setRefresh(!refresh);
    } catch (err) {
      console.log(err);
    }
  };

  return (
    <div className="p-4">
      <div className="flex  gap-2">
        <Icon
          onClick={() => navigate("/dashboard/companies")}
          className="text-4xl pr-2 cursor-pointer"
          icon="ion:arrow-back-circle-outline"
        />
        <h1 className="mb-4 text-2xl font-semibold">All Supervisors</h1>
      </div>
      {/* <h1 className="mb-4 text-2xl font-semibold">All Supervisors</h1> */}
      {supervisor?.length > 0 ? (
        <>
          <table className="min-w-full border border-collapse border-gray-300 shadow-lg table-auto">
            <thead>
              <tr className="bg-gray-200">
                <th className="px-4 py-2 border border-gray-300">Name</th>
                <th className="px-4 py-2 border border-gray-300">Email</th>
                 {admin.role === "administrator" &&
                <th className="px-4 py-2 border border-gray-300">Action</th>}
              </tr>
            </thead>
            <tbody>
              {supervisor.map((supervisor, index) => (
                <tr
                  key={supervisor.id}
                  className={index % 2 === 0 ? "bg-gray-100" : "bg-white"}
                >
                  <td className="px-4 py-2 border border-gray-300">
                    {supervisor.name}
                  </td>
                  <td className="px-4 py-2 border border-gray-300">
                    {supervisor.email}
                  </td>
                   {admin.role === "administrator" &&
                  <td className="px-4 py-2 border border-gray-300">
                    <div className="flex justify-center items-center gap-2">
                      <Icon
                        // onClick={() => handleEditClick(company)}
                        onClick={() => {
                          setUser(supervisor);
                          setOpenModal(true);
                        }}
                        className="text-lg text-blue-700 cursor-pointer"
                        icon="fluent:clipboard-text-edit-48-regular"
                      />
                      <Icon
                        onClick={() => {
                          // handleDeleteUser(supervisor);
                          setUser(supervisor);
                          setConfirmPopup(true);
                        }}
                        className="text-lg text-gray-700 cursor-pointer"
                        icon="mingcute:delete-2-fill"
                      />
                    </div>
                  </td>
}
                </tr>
              ))}
            </tbody>
          </table>
          {openModal && (
            <UserEditModal
              refresh={refresh}
              closeModal={setOpenModal}
              user={user}
              setRefresh={setRefresh}
            />
          )}
          {confirmPopup && (
            <PopConfirm
              closePopup={setConfirmPopup}
              confirm={handleDeleteUser}
              item={user}
            />
          )}
        </>
      ) : (
        <p>No Supervisors found</p>
      )}
    </div>
  );
}

export default AllSupervisor;
